import { render } from "./ContractDistributionEditKitForm.vue?vue&type=template&id=30dd17ca"
import script from "./ContractDistributionEditKitForm.vue?vue&type=script&lang=js"
export * from "./ContractDistributionEditKitForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__